$('.product-gallery-main-img .gallery-img-list').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			fade: true,
			asNavFor: '.product-gallery__thumbnails .thumbnail-list',
            dots: true
		});
		$('.product-gallery__thumbnails .thumbnail-list').slick({
			slidesToShow: 5,
			slidesToScroll: 1,
			vertical:true,
			asNavFor: '.product-gallery-main-img .gallery-img-list',
			dots: false,
			focusOnSelect: true,
			verticalSwiping:true,
			prevArrow: ".product-gallery__thumbnails .thumbnail-slider-controls .thumb-prev",
         	nextArrow: ".product-gallery__thumbnails .thumbnail-slider-controls .thumb-next",
			responsive: [
			{
				breakpoint: 992,
				settings: {
				  vertical: false,
				}
			},
			{
			  breakpoint: 768,
			  settings: {
				vertical: false,
			  }
			},
			{
			  breakpoint: 580,
			  settings: {
				vertical: false,
				slidesToShow: 3,
			  }
			},
			{
			  breakpoint: 380,
			  settings: {
				vertical: false,
				slidesToShow: 2,
			  }
			}
			]
		});


document.querySelectorAll('.product-gallery-main-img .slick-slide .product-gallery__thumbnail-item').forEach(item => {
  item.addEventListener('mousemove', e => {
    const img = item.querySelector('img');
    const { left, top, width, height } = item.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;
    const centerX = x / width * 100;
    const centerY = y / height * 100;
    img.style.transformOrigin = `${centerX}% ${centerY}%`;
  });

  item.addEventListener('mouseleave', () => {
    const img = item.querySelector('img');
    img.style.transformOrigin = 'center center';
  });
});